import React, { useEffect, useState } from 'react';
import Link from 'next/link';
import { LinkGroup } from 'shared/types/content/MegaMenu';
import Typography from 'components/commercetools-ui/atoms/typography';
import { useFormat } from 'helpers/hooks/useFormat';
import Image from 'frontastic/lib/image';
import {
  getUpdatedNavLinks,
  LevelTwoCategory,
  LevelTwoCategorySection,
  LevelTwoLink,
} from '../../../header-navigation-top-level';
import { menu } from '../../../index';
import { Level2Item, Level3Item, MenuItem } from 'frontastic/tastics/header/mega-menu';
import { useRouter } from 'next/navigation';

interface MobileMenu {
  data: menu | undefined;
  isOpen: boolean;
}
interface MetaData {
  schema: string;
  deliveryId: string;
  name: string;
}
interface Image {
  defaultHost: string;
  endpoint: string;
  name: string;
  id: string;
  _meta: MetaData;
}
interface levelOneCategory {
  mobileImage?: string;
  Heading: string;
  Url: string;
  Image: Image;
  levelTwoCategories: LevelTwoCategory[];
}

export type Data = {
  data?: MenuItem | undefined;
  isOpen: boolean;
};
const MobileMenuDefault = (data: Data) => {
  const { formatMessage } = useFormat({ name: 'common' });
  const updatedNavLinks = getUpdatedNavLinks();
  const [selectedCategory, setSelectedCategory] = useState<string | null>(null);
  const [expandedKey, setExpandedKey] = useState<string | null>(null);
  const [selectedL2Category, setSelectedL2Category] = useState<string | null>(null);
  const [transitionClass, setTransitionClass] = useState<string>('');
  const [selectedData, setSelectedData] = useState<MenuItem>();
  const router = useRouter();
  const menuItems: any = data?.data;
  menuItems?.forEach((menuItem: MenuItem) => {
    const matchingNavLink = updatedNavLinks?.find((navLink) => {
      const menuHeading = menuItem?.name?.toLowerCase().trim();
      const navName = navLink?.name?.toLowerCase().trim();
      return menuHeading === navName;
    });
    if (matchingNavLink) {
      menuItem.mobileImage = matchingNavLink?.imgURL;
    }
  });

  const handleCategoryClick = (name: string) => {
    setTransitionClass('translate-x-full');
    setTimeout(() => {
      setSelectedCategory(name === selectedCategory ? null : name);
      setExpandedKey(null);
      setSelectedL2Category(null);
      setTransitionClass('');
    }, 300);
  };

  const handleL2CategoryClick = (name: string, selectedL1: MenuItem, shopAllItem: Level2Item) => {
    if (shopAllItem && shopAllItem?.name === name) {
      return router.push((shopAllItem as any)?.url);
    } else {
      setTransitionClass('translate-x-full');
      setTimeout(() => {
        setSelectedL2Category(name);
        setTransitionClass('');
        setSelectedData(selectedL1);
      }, 300);
    }
  };

  const handleBackClick = () => {
    setTransitionClass('translate-x-full');
    setTimeout(() => {
      if (selectedL2Category) {
        setSelectedL2Category(null);
      } else {
        setSelectedCategory(null);
      }
      setTransitionClass('');
    }, 300);
  };

  if (selectedL2Category) {
    const selectedL2Data = (selectedData as any)?.level2?.filter((i: Level2Item) => {
      return i?.name === selectedL2Category;
    });
    const isShopAll = selectedL2Data?.[0]?.level3?.length === 0;

    return (
      <div className={`transition-transform duration-300 ease-in-out ${transitionClass}`}>
        {!isShopAll && (
          <div className={` mb-4 flex items-center gap-4 bg-[#ededed] py-20`}>
            <div onClick={handleBackClick} className="cursor-pointer ">
              <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="h-20 w-20">
                <path
                  d="M14.2893 18.2929C13.8988 18.6834 13.2656 18.6834 12.8751 18.2929L7.9877 13.4006C7.2073 12.6195 7.2076 11.3537 7.9883 10.5729L12.8787 5.68254C13.2692 5.29202 13.9024 5.29202 14.2929 5.68254C14.6834 6.07307 14.6834 6.70623 14.2929 7.09676L10.1073 11.2824C9.71676 11.6729 9.71676 12.3061 10.1073 12.6966L14.2893 16.8787C14.6798 17.2692 14.6798 17.9023 14.2893 18.2929Z"
                  fill="#0F0F0F"
                ></path>
              </svg>
            </div>
            <Typography className=" text-md cursor-pointer uppercase  text-primary-black">
              {selectedL2Category}
            </Typography>
          </div>
        )}
        <ul>
          {selectedL2Data?.[0]?.level3?.map((value: Level3Item, j: number) => (
            <Link key={j} href={value?.url ? value?.url : ''}>
              <li key={j} className="ml-25 cursor-pointer py-10 text-[#474747]">
                {value?.name}
              </li>
            </Link>
          ))}
        </ul>
      </div>
    );
  }

  if (selectedCategory) {
    const selectedL1 = menuItems?.find((item: MenuItem) => item?.name === selectedCategory);
    const isShopAll = selectedL1?.level2.some((i: Level2Item) => {
      return i?.level3?.length === 0 && i?.name?.toLowerCase() === 'shop all';
    });
    const shopAllItem = selectedL1?.level2.find((i: Level2Item) => {
      return i?.level3?.length === 0 && i?.name?.toLowerCase() === 'shop all';
    });
    return (
      <div className={`transition-transform duration-300 ease-in-out ${transitionClass}`}>
        <div className="mb-4 flex items-center gap-4 bg-[#ededed] py-20">
          <div onClick={handleBackClick} className="cursor-pointer">
            <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="h-20 w-20">
              <path
                d="M14.2893 18.2929C13.8988 18.6834 13.2656 18.6834 12.8751 18.2929L7.9877 13.4006C7.2073 12.6195 7.2076 11.3537 7.9883 10.5729L12.8787 5.68254C13.2692 5.29202 13.9024 5.29202 14.2929 5.68254C14.6834 6.07307 14.6834 6.70623 14.2929 7.09676L10.1073 11.2824C9.71676 11.6729 9.71676 12.3061 10.1073 12.6966L14.2893 16.8787C14.6798 17.2692 14.6798 17.9023 14.2893 18.2929Z"
                fill="#0F0F0F"
              ></path>
            </svg>
          </div>
          <Typography className="text-md uppercase text-primary-black">{selectedCategory}</Typography>
        </div>
        {selectedCategory?.toLowerCase() === 'brands' ? (
          <div className="max-h-200 overflow-y-auto">
            <ul className="scrollable">
              {selectedL1?.level2?.map((level2: Level2Item, levelOneIndex: number) => (
                <Link key={levelOneIndex} href={level2?.url ? level2?.url : ''}>
                  <li key={`${levelOneIndex}`} className="ml-20 p-5">
                    {level2?.name}
                  </li>
                </Link>
              ))}
            </ul>
          </div>
        ) : (
          <ul>
            {selectedL1?.level2.map((item: Level2Item, index: number) => {
              // const url: any = isShopAll ? item.url : '';
              if (item?.HideFromMobile) {
                return null;
              }
              return (
                <div key={index} className="ml-25">
                  <div
                    className="flex justify-between font-bold "
                    onClick={() => {
                      handleL2CategoryClick(item?.name, selectedL1, shopAllItem);
                    }}
                  >
                    <p className="cursor-pointer  py-10">{item?.name}</p>

                    <div
                      className={`mr-24 w-[20px] cursor-pointer ${
                        (item?.name === 'Shop All' && isShopAll) || selectedL1?.name.toLowerCase() === 'brands'
                          ? 'hidden'
                          : 'block'
                      }`}
                    >
                      <svg
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        className={`transition-transform duration-300 ${expandedKey === item?.name ? 'rotate-90' : ''}`}
                      >
                        <path
                          d="M9.71069 18.2929C10.1012 18.6834 10.7344 18.6834 11.1249 18.2929L16.0123 13.4006C16.7927 12.6195 16.7924 11.3537 16.0117 10.5729L11.1213 5.68254C10.7308 5.29202 10.0976 5.29202 9.70708 5.68254C9.31655 6.07307 9.31655 6.70623 9.70708 7.09676L13.8927 11.2824C14.2833 11.6729 14.2833 12.3061 13.8927 12.6966L9.71069 16.8787C9.32016 17.2692 9.32016 17.9023 9.71069 18.2929Z"
                          fill="#0F0F0F"
                        ></path>
                      </svg>
                    </div>
                  </div>
                </div>
              );
            })}
          </ul>
        )}
      </div>
    );
  }

  return !menuItems ? (
    <div>
      <ul>
        {updatedNavLinks?.map(({ categoryId, url, name, imgURL }) => (
          <li key={categoryId} className="list-none border-y">
            <a className="flex cursor-pointer items-center gap-16 px-24 py-16" href={url}>
              <div className="relative h-40 w-40">
                <Image fill src={imgURL} style={{ objectFit: 'cover' }} />
              </div>
              <Typography className="font-bold uppercase text-primary-black">
                {formatMessage({ id: categoryId, defaultMessage: name })}
              </Typography>
            </a>
          </li>
        ))}
      </ul>
    </div>
  ) : (
    <div className={`transition-transform duration-300 ease-in-out ${transitionClass}`}>
      <ul>
        {menuItems?.map(
          (i: MenuItem, index: number) =>
            (selectedCategory === i?.name || selectedCategory === null) && (
              <li key={index} className="list-none border-b">
                <div
                  className="flex cursor-pointer items-center gap-16 px-24 py-16"
                  onClick={() => handleCategoryClick(i?.name)}
                >
                  <div className="relative h-40 w-40">
                    <Image
                      fill
                      src={
                        i.ImageForMobile
                          ? `https://${i?.ImageForMobile?.defaultHost}/i/${i?.ImageForMobile?.endpoint}/${i?.ImageForMobile?.name}`
                          : i?.mobileImage
                      }
                      alt={i?.AltTextForMobile}
                      style={{ objectFit: 'cover' }}
                    />
                  </div>{' '}
                  <Typography className="cursor-pointer font-bold uppercase  text-primary-black">
                    {formatMessage({ id: i?.name, defaultMessage: i?.name })}
                  </Typography>
                  {/* <div className="ml-auto w-[20px]">
                    <svg */}
                  {/* <div className="ml-auto w-[20px]"> */}
                  {/* <svg
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      className={`transition-transform duration-300 ${selectedCategory === i?.name ? 'rotate-90' : ''}`}
                    >
                      <path
                        d="M9.71069 18.2929C10.1012 18.6834 10.7344 18.6834 11.1249 18.2929L16.0123 13.4006C16.7927 12.6195 16.7924 11.3537 16.0117 10.5729L11.1213 5.68254C10.7308 5.29202 10.0976 5.29202 9.70708 5.68254C9.31655 6.07307 9.31655 6.70623 9.70708 7.09676L13.8927 11.2824C14.2833 11.6729 14.2833 12.3061 13.8927 12.6966L9.71069 16.8787C9.32016 17.2692 9.32016 17.9023 9.71069 18.2929Z"
                        fill="#0F0F0F"
                      ></path>
                    </svg> */}
                  {/* <img
                      src="/icons/ag-icons/chev-right.svg"
                      height={20}
                      className={`rounded-sm border border-neutral-200 bg-white p-1 transition-transform duration-300 ${
                        selectedCategory === i?.name ? 'rotate-90' : ''
                      }`}
                    /> */}
                  {/* </div> */}
                  <div className="ml-auto w-[20px] rounded-sm">
                    <img
                      src="/icons/ag-icons/chev-right.svg"
                      height={20}
                      loading="lazy"
                      alt="chevron right"
                      className={`transition-transform duration-300 ${selectedCategory === i?.name ? 'rotate-90' : ''}`}
                    />
                  </div>
                </div>
              </li>
            ),
        )}
      </ul>
    </div>
  );
};

export default MobileMenuDefault;
